
<template>
 <v-layout row>
    <v-flex xs12>
      <v-toolbar color="" >
          <v-toolbar-title class="text-xs-center">Chats</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>Mensajes de la centrar</v-subheader>
          <template v-for="item in items">
          <v-list-tile  avatar :key="item.id">
            
            <v-list-tile-content>
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon>
            </v-list-tile-action>
            
          </v-list-tile>
          <v-divider :key="item.id + 'e'"></v-divider>
          </template>
          
        </v-list>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
    data () {
      return {
        items: [
          { id: 0, active: true, title: 'Jason Oner', avatar: '/static/doc-images/lists/1.jpg' },
          { id: 1, active: true, title: 'Ranee Carlson', avatar: '/static/doc-images/lists/2.jpg' },
          { id: 2, title: 'Cindy Baker', avatar: '/static/doc-images/lists/3.jpg' },
          { id: 3, title: 'Ali Connors', avatar: '/static/doc-images/lists/4.jpg' }
        ],
        items2: [
          { title: 'Travis Howard', avatar: '/static/doc-images/lists/5.jpg' }
        ]
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
